import { makeStyles } from "@mui/styles";
import React from "react";
import { Typography } from "../Typography";
import mentalSliderImg1 from "../../asset/mentalSliderImg1.png";

const useStyles = makeStyles((theme) => ({
  container: {
    maxWdith: 230,
    width: 230,
    height: 300,
    display: "flex",
    flexDirection: "column",
    // border: "3px solid orange",
  },
  moduleImg: {
    width: 230,
    height: 170,
    borderRadius: "10px 10px 0px 0px",
    // borderBottom: "1px solid orange",
    display: "flex",
    alignItems: "end",
    justifyContent: "center",
    backgroundColor: "#EB5FE5",
  },
  moduleTxt: {
    // width: 230,
    height: 193,
    display: "flex",
    borderRadius: "0px 0px 10px 10px",
    padding: 5,
    // border: "1px solid blue",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    backgroundColor: "#FDF5FD",
    // paddingLeft: 5,
  },
}));

export const MentalMobileModuleCon1 = () => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.moduleImg}>
        <img
          src={mentalSliderImg1}
          alt="mentalSliderImg1"
          style={{ width: 100 }}
        />
      </div>

      <div className={classes.moduleTxt}>
        <div
          style={{
            backgroundColor: "#EB5FE5",
            borderRadius: 10,
            width: 97,
            height: 28,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 5,
          }}
        >
          <Typography variant="SimModuleText" style={{ color: "#fff" }}>
            시나리오 1
          </Typography>
        </div>

        <div style={{ wordBreak: "keep-all", textAlign: "center" }}>
          <Typography
            variant="SimModuleSubText"
            style={{ textAlign: "justify" }}
          >
            "병원에 와도 좋아지는게 없어요."
          </Typography>
        </div>
      </div>
    </div>
  );
};
